import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface TipoConflictoPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface TipoConflicto {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface TipoConflictoResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class TipoConflictoService {
  private readonly apiUrl = `${environment.apiUrl}/api/tipo_conflicto`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getAll(): Observable<TipoConflicto[]> {
    return this.http.get<TipoConflicto[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<TipoConflicto> {
    return this.http.get<TipoConflicto>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear
  create(
    payload: TipoConflictoPayload
  ): Observable<TipoConflictoResponse> {
    return this.http.post<TipoConflictoResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar
  update(
    id: number,
    payload: Partial<TipoConflictoPayload>
  ): Observable<TipoConflictoResponse> {
    return this.http.put<TipoConflictoResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar
  inactivar(id: number): Observable<TipoConflictoResponse> {
    return this.http.put<TipoConflictoResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar
  activar(id: number): Observable<TipoConflictoResponse> {
    return this.http.put<TipoConflictoResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}